import React from 'react';
import mergeRefs from 'react-merge-refs';
import useEffect from '../../utils/use_effect';
import useStyles from './use_styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
var KeepPlaceholderOnFocus = _ref => {
  var {
    children,
    enabled: _enabled,
    hasIcon = false,
    hasLabel = false
  } = _ref;
  var [enabled, setEnabled] = React.useState(undefined);
  var [focused, setFocused] = React.useState(false);
  var inputRef = React.useRef();
  useEffect(() => {
    if (_enabled === undefined) {
      var e = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0;
      setEnabled(e);
    } else {
      setEnabled(_enabled);
    }
  }, [_enabled]);
  var handleHandler = handler => event => {
    var isFocused = document.activeElement === inputRef.current;
    if (isFocused !== focused) setFocused(isFocused);
    if (handler) handler(event);
  };
  var {
    placeholder
  } = children.props;
  var visible = Boolean(inputRef.current && !inputRef.current.value && focused);
  var styles = useStyles({
    hasIcon,
    hasLabel,
    visible
  });
  if (enabled && placeholder) {
    var {
      onBlur,
      onFocus
    } = children.props;
    return ___EmotionJSX("div", {
      css: styles
    }, ___EmotionJSX("span", {
      "data-visible": visible,
      className: "vn-placeholder_ie"
    }, placeholder), /*#__PURE__*/React.cloneElement(children, {
      onBlur: handleHandler(onBlur),
      onFocus: handleHandler(onFocus),
      ref: mergeRefs(children.ref ? [inputRef, children.ref] : [inputRef])
    }));
  }
  return children;
};
export default KeepPlaceholderOnFocus;